class Language {
    constructor($rootElement) {
        this.$rootElement = $rootElement;
    }

    getCurrentLanguage() {
        return this.$rootElement.attr('lang');
    }
}

Language.$inject = ['$rootElement'];

export default Language;